import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            tasks: [],
            pages: {},
            current: {}
        };
    },

    mutations: {
        setTasks(state, data) {
            state.tasks = data;
        },
        setPages(state, data) {
            state.pages = data;
        },
        setCurrent(state, data) {
            state.current = data;
        },
        clearStore(state) {
            state.tasks = {};
            state.current = {};
            state.pages = {};
        }
    },
    actions: {
        getTasksFiltered({ state, commit }, params) {
            return new Promise((resolve, reject) => {
                api.get('/task/?' + qs.stringify(params)).then(response => {
                    commit('setTasks', response.data.data);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        getPaginatedList({ state, commit }, params) {
            return new Promise((resolve, reject) => {
                api.get('/task/?' + qs.stringify(params)).then(response => {
                    commit('setTasks', response.data.data);
                    commit('setPages', response.data.meta);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        getTask(context, taskId) {
            return new Promise((resolve, reject) => {
                api.get('/task/' + taskId).then(
                    response => {
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        },
        updateTask(context, { id, data }) {
            return new Promise((resolve, reject) => {
                api.post('/task/' + id, data).then(
                    response => {
                        resolve(response);
                    }).catch(
                    error => {
                        reject(error);
                    }).finally(() => {
                    api.defaults.headers['Content-Type'] = 'application/json';
                });
            });
        },
        createTask(context, { id, data }) {
            return new Promise((resolve, reject) => {
                api.post('/task/', data).then(
                    response => {
                        resolve(response);
                    }).catch(
                    error => {
                        reject(error);
                    }).finally(() => {
                    api.defaults.headers['Content-Type'] = 'application/json';
                });
            });
        },
        async getFile({ state, commit }, id) {
            try {
                api.defaults.responseType = 'blob';
                return await api.get(`/task/file/${id}`);
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            } finally {
                api.defaults.responseType = '';
            }
        },
        async getTaskRelatedMetric({ state, commit }, { entityType, entityId, counters }) {
            try {
                return await api.get(`/task/metric/${entityType}/${entityId}/${counters}`);
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        }
    }
};

export default store;
